import { SelectOption } from "../../../../../../shared/interfaces";

export enum PRELIQUIDATIONS_STATES {
    EN_PROCESO_WEB = '1',
    EN_PROCESO_GAUS = '2',
    ELIMINADA = '3',
    PROCESADA = '4',
    RECIBIDA = '5',
    GUARDADA = '6',
    VENCIDA = '7',
} 

export const statesPreLiquidationsFilterForm: Array<SelectOption> = [
    {
        label: 'EN PROCESO WEB',
        value: PRELIQUIDATIONS_STATES.EN_PROCESO_WEB,
    },
    {
        label: 'EN PROCESO GAUS',
        value: PRELIQUIDATIONS_STATES.EN_PROCESO_GAUS,
    },
    {
        label: 'ELIMINADA',
        value: PRELIQUIDATIONS_STATES.ELIMINADA,
    },
    {
        label: 'PROCESADA',
        value: PRELIQUIDATIONS_STATES.PROCESADA,
    },
    {
        label: 'RECIBIDA',
        value: PRELIQUIDATIONS_STATES.RECIBIDA,
    },
    {
        label: 'GUARDADA',
        value: PRELIQUIDATIONS_STATES.GUARDADA,
    },
    {
        label: 'VENCIDA',
        value: PRELIQUIDATIONS_STATES.VENCIDA,
    },
];